import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo2.png';
import './NavbarRedesign.css';

function NavbarRedesign() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  function goHome() {
    navigate('/');
  }

  function goToEligibility() {
    navigate('/eligibility');
  }

  function goToBlog() {
    navigate('/blog');
  }

  function goToContact() {
    navigate('/contact');
  }

  return (
    <>
      <header className="nav-redesign">
        <a className="nav-redesign__logo" href="/" onClick={function(e) { e.preventDefault(); navigate('/'); window.scrollTo(0, 0); }}>
          <span className="nav-redesign__logo-text">Easy Global Entry</span>
        </a>

        <nav className="nav-redesign__links">
          <a className="nav-redesign__link" href="/eligibility" onClick={function(e) { e.preventDefault(); navigate('/eligibility'); window.scrollTo(0, 0); }}>Eligibility</a>
          <a className="nav-redesign__link" href="/blog" onClick={function(e) { e.preventDefault(); navigate('/blog'); window.scrollTo(0, 0); }}>Blog</a>
          <a className="nav-redesign__link" href="/contact" onClick={function(e) { e.preventDefault(); navigate('/contact'); window.scrollTo(0, 0); }}>Contact</a>
        </nav>

        <button
          className="nav-redesign__menu-icon"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? '✕' : '☰'}
        </button>
      </header>

      <div className={`nav-redesign__mobile-nav ${mobileMenuOpen ? 'nav-redesign__mobile-nav--open' : ''}`}>
        <a className="nav-redesign__mobile-link" href="/eligibility" onClick={function(e) { e.preventDefault(); navigate('/eligibility'); window.scrollTo(0, 0); setMobileMenuOpen(false); }}>Eligibility</a>
        <a className="nav-redesign__mobile-link" href="/blog" onClick={function(e) { e.preventDefault(); navigate('/blog'); window.scrollTo(0, 0); setMobileMenuOpen(false); }}>Blog</a>
        <a className="nav-redesign__mobile-link" href="/contact" onClick={function(e) { e.preventDefault(); navigate('/contact'); window.scrollTo(0, 0); setMobileMenuOpen(false); }}>Contact</a>
      </div>
    </>
  );
}

export default NavbarRedesign;
